import useExperimentBucket from '~/hooks/common/experiments/useExperimentBucket';

export default function useIsInVaultExperiment(): boolean {
  return (
    useExperimentBucket('car-merch-ui-vdp-vault-why-buys-hotswap') ===
    'treatment'
  );
}
